import React from 'react'
import { Grid } from '@mui/material'
import { CursoEscolarSelect } from 'components/forms/components/Select/custom'

export default function CursosVeranoTemplate({ register, errors, reset, setValue }) {
    return (
        <Grid container columnSpacing={{ xs: 1, sm: 2, md: 3 }} mt={4}>
            <Grid item xs={3} border={'1px solid red'}>
                Año
            </Grid>

            <Grid item xs={3} border={'1px solid black'}>
                Tipo de Curso
            </Grid>

            <Grid item xs={3} border={'1px solid red'}>
                <CursoEscolarSelect name={`id_curso_escolar`} register={register} errors={errors} wantToReset={reset} defaultValue={null} setValue={setValue} searcheable />
            </Grid>

            <Grid item xs={3} border={'1px solid black'}>
                Opción
            </Grid>
        </Grid>
    )
}
